import { render } from "./InscriptionRow.vue?vue&type=template&id=68f4101a"
import script from "./InscriptionRow.vue?vue&type=script&lang=js"
export * from "./InscriptionRow.vue?vue&type=script&lang=js"

import "./InscriptionRow.vue?vue&type=style&index=0&id=68f4101a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__